import {
  Divider,
  Drawer,
  Typography,
  IconButton,
  Stack,
  TextField,
  Button,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'
import { createQuestionnaireTemplate } from '../../../../apis/questionnaireApis'
import { useState } from 'react'
import { history } from '../../../../_helpers'
import { useDispatch, useSelector } from 'react-redux'
import { questionnaireTemplateActions, toastActions } from '../../../../_actions'

const QuestionnaireTemplatesCreationDrawer = ({ handleClose }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const app = useSelector((state) => state.app)
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    name: '',
    description: '',
  })

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }))
  }

  const isDisabled = !formData.name.trim() || !formData.description.trim();

  const handleCreateQuestionnaireTemplate = async () => {
    const { name, description } = formData
    const payload = {
      name: name.trim(),
      description: description.trim(),
    }

    try {
      setLoading(true)
      const response = await createQuestionnaireTemplate(payload)
      if (response.status === 200) {
        const templateId = response.data.id
        history.push(`/vragenlijst-sjabloon/${templateId}`)
      }
    } catch (error) {
      console.log(error)
      dispatch(toastActions.error(t("error.header")))
    }
    finally {
      dispatch(questionnaireTemplateActions.questionnaireFetchTemplateLists(t, app))
      handleClose()
      setLoading(false)
    }
  }

  return (
    <Drawer
      anchor="right"
      open={true}
      onClose={handleClose}
      hideBackdrop
      PaperProps={{
        sx: {
          width: { xs: '100%', md: 508 },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ px: 2.5, py: 1 }}
      >
        <Typography variant="h6">{t('template.create')}</Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <Divider />
      <Stack
        spacing={2}
        sx={{
          flex: 1,
          px: 2,
          py: 3,
          overflowY: 'auto',
          bgcolor: 'background.paper',
        }}
      >
        <TextField
          label={t('general.template.name')}
          size="small"
          autoComplete='off'
          fullWidth
          value={formData.name}
          onChange={handleChange('name')}
          slotProps={{
            htmlInput: { maxLength: 100 },
            inputLabel: {
              shrink: true,
            }
          }}
        />

        <TextField
          label={t('general.description')}
          size="small"
          fullWidth
          multiline
          value={formData.description}
          onChange={handleChange('description')}
          slotProps={{
            htmlInput: { maxLength: 500 },
            inputLabel: {
              shrink: true,
            }
          }}
        />
      </Stack>
      <Divider />

      <Stack
       direction="row"
        spacing={1}
        p={2}
      >
        <Button fullWidth variant="outlined" color='inherit' onClick={handleClose}>
          {t('general.cancel')}
        </Button>
        <Button
          fullWidth
          disabled={isDisabled || loading}
          loading={loading}
          variant="contained"
          onClick={handleCreateQuestionnaireTemplate}
        >
          {t('general.create')}
        </Button>
      </Stack>
    </Drawer>
  )
}

export default QuestionnaireTemplatesCreationDrawer
